
import { AppProviders } from './providers/AppProviders';
import AppRoutes from './routes';
import MissingEndpointsReporter from './components/MissingEndpointsReporter';

// Determine if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

function App() {
  return (
    <>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
      
      {/* Display missing endpoints reporter only in development mode */}
      {isDevelopment && <MissingEndpointsReporter showInUI={true} />}
    </>
  );
}

export default App;